import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from 'hypnotica-styled-components/ThemeProvider';
import Themes from 'hypnotica-styled-components/Themes';
import ReactGA from 'react-ga4';

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function (search, replacement) {
    return this.split(search).join(replacement);
  };
}

if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize([
    {
      trackingId: 'G-K897S9QGKR',
    },
    {
      trackingId: 'AW-17165060758',
    },
  ]);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={Themes}>
    <App />
  </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
